<!-- 正在开发中 -->
<template>
  <div class="warp">
    <div class="ongoing">
      <span>正在开发中!</span>
      <p>为您带来不便，请敬请期待~</p>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ongoing",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .ongoing {
    background: url("../../assets/images/ongoing.png") no-repeat left 4.6rem
      #e9f9ec;
    background-size: 100% auto;
    min-height: 80vh;
    margin-bottom: -1.45rem;
    text-align: center;
    span {
      font-size: 0.66rem;
      display: block;
      padding-top: 1.9rem;
    }
    p {
      padding: 0.2rem 0;
      font-style: 0.36rem;
    }
    a {
      width: 3.4rem;
      line-height: 0.9rem;
      font-style: 0.36rem;
      color: #fff;
      background-color: #4acb6c;
      border-radius: 1rem;
      box-shadow: 0px 16px 28px 0px rgba(48, 41, 155, 0.22);
      margin-top: 0.4rem;
      line-height: .9rem;
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/ongoing.vue